module.exports = __webpack_public_path__ + "static/media/PDVideo.29ea2111.mp4";